<script setup lang="ts">
import { useTranslations } from '@/composables/useTranslations.ts'
import { computed, onMounted } from 'vue'
import { usePageTitle } from '@/composables/usePageTitle.ts'
import { useUserStore } from '@/stores/user.store.ts'
import { storeToRefs } from 'pinia'
import { isNull } from 'lodash'
import { useRouter } from 'vue-router'
import { UserRoleId } from '@/enums.ts'

const userStore = useUserStore()
const { t } = useTranslations()
const router = useRouter()
const { projectSelected, userRoleId } = storeToRefs(userStore)
const title = computed(() => t('welcome.title'))

usePageTitle(title)

onMounted(() => {
  if (userRoleId.value === UserRoleId.ProjectOwner && !isNull(projectSelected.value)) {
    router.push({ path: `/${projectSelected.value.key}/chats` }) // TODO: Config?
  }
})
</script>

<template>
  <div class="flex flex-col items-center justify-center text-center mt-6">
    <img
      src="/project.svg"
      alt="hello"
      class=""
    />
    <div class="max-w-md">
      <h1 class="text-2xl font-bold mb-4 text-gray-800">{{ t('welcome.title') }}</h1>
      <p class="text-gray-600 mb-6">{{ t('welcome.description') }}</p>
    </div>
  </div>
</template>
